import { useNavigate, useLocation, matchRoutes } from 'react-router-dom';
import { mainRoutes } from '../config/routes.config';

export const useRouteUtils = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentRouteTab = location.state?.background;

  // Cast as any or RouteObject[] to satisfy the AgnosticRouteObject requirement
  const matches = matchRoutes(mainRoutes as any, location);
  
  // Use 'any' here as well so TS doesn't complain about the .label property
  const lastMatch = matches?.[matches.length - 1] as any;
  const dynamicModalRouteLabel = lastMatch?.route?.label ?? '';

  const handleModalNavigate = (path: string) => {
    navigate(path, { state: { background: location } });
  };

  const handleTabChange = (event: React.SyntheticEvent, value: string) => {
    navigate(value);
  };

  return {
    location,
    currentRouteTab,
    dynamicModalRouteLabel,
    matches,
    handleModalNavigate,
    handleTabChange,
    navigate
  };
};